import { Component, Input, OnInit } from '@angular/core';
import { EnvironmentService } from '../../../common/services/env-configuration/environment.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: false,
})
export class NotFoundComponent {
  @Input() code: string = '404';

  public codeNote = {
    404: 'Resource not found',
    403: 'Forbidden',
    400: 'Bad request',
    0: 'Connection problem',
  };

  constructor(private envService: EnvironmentService) {}

  public getEnvHome() {
    return '';
  }
}
